    document.addEventListener('DOMContentLoaded', function() {
        console.log('DOM fully loaded and parsed');
        const productCircles = document.querySelectorAll('.product-circle-page');
        console.log('Found product circles:', productCircles.length);

        // Check if device is mobile/tablet (screen width less than 768px)
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        console.log('Is mobile/tablet:', isMobile);

        // Only apply click/touch handlers for mobile and tablet
        if (isMobile) {
            productCircles.forEach(function(circle, idx) {
                // Add cursor pointer for better UX
                circle.style.cursor = 'pointer';
                
                let touchHandled = false;
                
                // Handle touch events for mobile
                circle.addEventListener('touchend', function(e) {
                    e.preventDefault(); // Prevent mouse events from firing
                    touchHandled = true;
                    
                    // Check current state before toggling
                    const wasActive = this.classList.contains('active');
                    
                    // Toggle active class on clicked circle
                    this.classList.toggle('active');
                    const status = this.classList.contains('active') ? 'activated' : 'deactivated';
                    console.log(`Circle ${idx + 1} was ${status} (touch).`);
                    
                    // Only close other circles when opening this one (not when closing)
                    if (!wasActive) {
                        productCircles.forEach(function(otherCircle) {
                            if (otherCircle !== circle) {
                                otherCircle.classList.remove('active');
                            }
                        });
                    }
                    
                    // Reset flag after a short delay
                    setTimeout(function() {
                        touchHandled = false;
                    }, 300);
                });
                
                // Handle click events for mobile/tablet
                circle.addEventListener('click', function(e) {
                    // Prevent duplicate firing if touch was already handled
                    if (touchHandled) {
                        return;
                    }
                    
                    // Check current state before toggling
                    const wasActive = this.classList.contains('active');
                    
                    // Toggle active class on clicked circle
                    this.classList.toggle('active');
                    const status = this.classList.contains('active') ? 'activated' : 'deactivated';
                    console.log(`Circle ${idx + 1} was ${status} (click).`);
                    
                    // Only close other circles when opening this one (not when closing)
                    if (!wasActive) {
                        productCircles.forEach(function(otherCircle) {
                            if (otherCircle !== circle) {
                                otherCircle.classList.remove('active');
                            }
                        });
                    }
                });
            });
        } else {
            console.log('Desktop mode: using CSS hover effects');
        }

        // Add NEW badge to all products with mood-new-product class
        console.log('Looking for .mood-new-product h3 elements...');
        const newProducts = document.querySelectorAll('.mood-new-product h3');
        console.log('Found newProducts:', newProducts.length);
        
        if (newProducts.length > 0) {
            newProducts.forEach(function(newProduct, index) {
                console.log(`Processing product ${index + 1}, original text:`, newProduct.textContent);
                const originalText = newProduct.textContent.trim();
                newProduct.innerHTML = `<span class="new-badge">NEW</span> ${originalText}`;
                console.log(`NEW badge added to product ${index + 1}`);
            });
        } else {
            console.log('Could not find any .mood-new-product h3 elements');
        }
    });

